import { graphqlFetch } from '@api/graphql/gql-fetch';
import {
	type ReviewsForGallery,
	getReviewsForGalleryQuery,
} from '@api/graphql/reviews/getReviewsForGallery';
import { mapReviewsForGallery } from '@api/reviews/getReviewsForGallery/mapper';
import { getUnifiedReviewsUrl } from '@api/reviews/url';
import { Logger } from '@utils/logger/logger';
import type { buildVariablesForReviewForGallery } from './build-variables';

type Variables = Awaited<ReturnType<typeof buildVariablesForReviewForGallery>>;

const headers = {
	'x-tenant-id': 'tk-us',
};
export const fetchReviewsForGallery = async (variables: Variables) => {
	try {
		const result = await graphqlFetch<ReviewsForGallery>({
			url: getUnifiedReviewsUrl(),
			query: getReviewsForGalleryQuery,
			variables,
			headers: new Headers(headers),
		});

		if (result.errors?.length) {
			const errors = result.errors.map((error) => new Error(error.message));
			for (const error of errors) {
				Logger.error({
					log_message: 'GraphQL Error fetching reviews for gallery',
					errorToLog: error,
					newRelic: true,
				});
			}
			throw errors;
		}

		return mapReviewsForGallery(result.data);
	} catch (e) {
		if (!Array.isArray(e)) {
			Logger.error({
				errorToLog: e,
				newRelic: true,
				log_message: 'Error fetching reviews for gallery',
			});
		}
		throw e;
	}
};
